import { createContext, useContext } from 'react';

import invariant from 'tiny-invariant';

export const CurrentEmployerContext = createContext<string | undefined>(undefined);

export function useCurrentEmployerId() {
  const id = useContext(CurrentEmployerContext);
  invariant(id, 'To use `useCurrentEmployerId` you must wrap your component in a `CurrentEmployerContext.Provider`');

  return id;
}
